module.exports = __webpack_public_path__ + "img/le_pain_quotidien.c85ea18b.jpg";